import { useParams, Link } from 'react-router-dom';
import { Col, Row, Divider, DatePicker, Checkbox, Modal } from 'antd';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DefaultLayout from '../components/DefaultLayout';
import Spinner from '../components/Spinner';
import { getAllCars } from '../redux/actions/carsActions';
import moment from 'moment';
import { bookCar } from '../redux/actions/bookingActions';
import StripeCheckout from 'react-stripe-checkout';
import 'aos/dist/aos.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'; // You can also use <link> for styles

const { RangePicker } = DatePicker;

function BookingCar( ) {
    const { cars } = useSelector((state) => state.cars);
    const { loading } = useSelector((state) => state.alerts);
    const [car, setcar] = useState({});
    const dispatch = useDispatch();
    const [from, setFrom] = useState();
    const [to, setTo] = useState();
    const [totalHours, setTotalHours] = useState(0);
    const [driver, setdriver] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const { id } = useParams();


    useEffect(() => {
        if (cars.length == 0) {
            dispatch(getAllCars());
        } else {
            setcar(cars.find((o) => o._id === (id)));
        }
    }, [cars]);

    useEffect(() => {
        setTotalAmount(totalHours * car.rentPerHour);
        if (driver) {
            setTotalAmount(totalAmount + 10 * totalHours);
        }
    }, [driver, totalHours]);

    function selectTimeSlots(values) {
        setFrom(moment(values[0]).format('MMM DD yyyy HH:mm'));
        setTo(moment(values[1]).format('MMM DD yyyy HH:mm'));

        setTotalHours(values[1].diff(values[0], 'hours'));
    }

  

    function onToken(token){
        const reqObj = {
            token,
            user: JSON.parse(localStorage.getItem('user'))._id,
            car: car._id,
            totalHours,
            totalAmount,
            driverRequired: driver,
            bookedTimeSlots: {
                from,
                to,
            },
        };
  
        dispatch(bookCar(reqObj));
    }

    return (
        <DefaultLayout>

            { loading && <Spinner /> }

            <h3 className='m-5'>Booking Section - <span> {car.name} </span></h3>

            <Row
                justify="center"
                className="d-flex align-items-center"
                style={{ minHeight: '90vh' }} >

                <Col lg={10} sm={24} xs={24} className='p-3'>
                    <img src={car.images?.[0]?.url} className="carimg2 bs1 w-100" data-aos='flip-left' data-aos-duration='1500'/>
                </Col>

                <Col lg={10} sm={24} xs={24} className="text-right">
                    <Divider dashed style={{ borderColor: '#000' }}>
                        <span><strong>Car Info</strong></span>
                    </Divider>
                    <div style={{ textAlign: 'right' }}>
                        <p>{car.name} </p>
                        <p>{car.rentPerHour} USD/- Per Rental hour</p>
                        <p>Fuel Type : {car.fuelType}</p>
                        <p>Max Persons : {car.capacity}</p>
                    </div>

                    <Divider dashed style={{ borderColor: '#000' }}>
                        <span><strong>Select Time Slots</strong></span>
                    </Divider>

                    <RangePicker
                        showTime={{ format: 'HH:mm' }}
                        format="MMM DD yyyy HH:mm"
                        onChange={selectTimeSlots} />

                    <br />

                    <button
                        className="btn1 mt-2"
                        onClick={() => {
                            setShowModal(true);
                        }} >
                        See Booked Slots
                    </button>

                    {from && to && (
                        <div>
                            <p>
                                Total Hours : <b>{totalHours}</b>
                            </p>
                            <p>
                                Rent Per Hour : <b>{car.rentPerHour}</b> USD/-
                            </p>
                            <Checkbox
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setdriver(true);
                                    } else {
                                        setdriver(false);
                                    }
                                }} >
                                Driver Required
                            </Checkbox>

                            <h3>Total Amount : {totalAmount}</h3>

                            <StripeCheckout
                                shippingAddress
                                token={onToken}
                                currency='USD'
                                amount={totalAmount * 10}
                                stripeKey="pk_test_51KsMSaLaLCVvQDVzKn5SoiWj1PbxMAKDgjPNtKatlXi6ax4mhTcDcJ63tiV69vdMRID8lI1Egpc8w8ppm9icD5vX00Opmvp2hQ">
                                <button className="btn1">
                                    Book Now
                                </button>
                            </StripeCheckout>

                        </div>
                    )}
                </Col>

                {car.name && (
                    <Modal
                        visible={showModal}
                        closable={false}
                        footer={false}
                        title="Booked time slots">
                        <div className="p-2">
                            { car.bookedTimeSlots.map((slot, index) => {
                                return (
                                    <button key={index} className="btn1 mt-2">
                                        {slot.from} - {slot.to}
                                    </button>
                                );
                            })}

                            <div className="text-right mt-5">
                                <button
                                    className="btn1"
                                    onClick={() => {
                                        setShowModal(false);
                                    }} >
                                    CLOSE
                                </button>
                            </div>
                        </div>
                    </Modal>
                )}
                
                <Col lg={10} sm={24} xs={24} className="text-right p-3 mt-5">
                    <div>
                        <button className="btn1" style={{backgroundColor: 'orangered', color: 'white'}}>
                            <Link className='book' to={`/cardetails/${car._id}`}>
                                <FontAwesomeIcon icon={faAngleLeft} size="3x" className='m-0' style={{color: 'orangered'}}/>Back
                            </Link>
                        </button>
                    </div>
                </Col>
            </Row>
        </DefaultLayout>
    );
}

export default BookingCar;
